import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { api, imgUrl } from "@/api";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";

export default function PPDBPage() {
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/ppdb").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-20" data-testid="ppdb-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-emerald-950 tracking-tight">{t("ppdb.title")}</h1>
        <p className="text-slate-600 mt-3 max-w-2xl">{t("ppdb.subtitle")}</p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-12">
        {items.map((s, i) => (
          <motion.div
            key={s.id}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 * i }}
            className="group bg-white rounded-xl border border-emerald-900/10 shadow-sm overflow-hidden"
            data-testid={`ppdb-card-${s.id}`}
          >
            <div className="relative aspect-[21/9] overflow-hidden bg-emerald-50">
              {s.image && <img src={imgUrl(s.image)} alt={s.nama} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />}
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/80 via-transparent to-transparent" />
              <h3 className="absolute bottom-5 left-6 right-6 font-display text-2xl sm:text-3xl font-bold text-white">{s.nama}</h3>
            </div>
            <div className="p-6 flex items-center justify-between gap-4">
              <p className="text-sm text-slate-600">{s.deskripsi}</p>
              {s.url && (
                <Button asChild className="rounded-full bg-emerald-800 hover:bg-emerald-900 shrink-0">
                  <a href={s.url} target="_blank" rel="noopener noreferrer" data-testid={`ppdb-visit-${s.id}`}>
                    {t("ppdb.visit")} <ExternalLink className="h-4 w-4 ml-2" />
                  </a>
                </Button>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
